import React, { Component } from 'react';
import './App.css';

class App extends Component {
  render() {
    document.title = 'magjac Interactive';
    return (
      <div className="App">
        <header className="App-header">
          <link rel="icon" href=""/>
          <h1 className="App-title">magjac Interactive</h1>
        </header>
        <p className="App-intro">
          Start the <a href="/graphviz-visual-editor">Graphviz Visual Editor</a> 
        </p>
        <footer className="App-footer">
        <h1 className="App-trailer">&copy; 2020 Magnus Jacobsson Interactive AB, Stockholm, Sweden</h1>
        </footer>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js